import React from "react";
import HomeComponent from "../components/Home/HomeComponent";
import BackgroundCheckPage from "./BackgroundCheck/BackgroundCheckPage";
import { Routes } from "../routes";

const HomePage = () => {
	if (window.location.href.includes("backgroundcheck")) {
		document.title = "Background Check"
		window.location.href = Routes.BackgroundCheckPage.path
		return;
	} else {
		document.title = "Data Worker"
	}
	return <HomeComponent />;
};

export default HomePage